Mmg.addShortcode(

  /**
   * @param {string} shortcodeName The name of the shortcode
   * @param {string} selector The selector used to locate this shortcode in the DOM
   * @param {callable} callback The callback function applied to every element matching the selector
   */
  'hotness_index',
  '.sc-hotness-index',

  /**
   *
   * Shortcode callback
   *
   * The shortcode callback receives the following parameters:
   *
   * @param {Element} el The shortcode's DOM element
   * @param {object} model The data model passed to the shortcode instance in data-json attribute
   * @param {jQuery} $ The callback function applied to every element matching the selector
   * @param {string} selector The shortcode selector that was passed to addShortcode
   * @param {string} className The name of the shortcode class
   */
  (el, model, $, selector, className) => {

    // Widget Declarations
    const $this = $(el);
    const modalTrigger = `${selector}__modal-trigger`;
    const $content = $(`${selector}__modal-content`);

    /**
     * Initialize the widget
     */
    (function init(){    
      addEvents();
    })();

    /**
     * Handle UI events
     */
    function addEvents() {
      $this.on('vclick', modalTrigger, handleClick);
    }

    /**
     * Get the content and render the modal
     */
    function handleClick() {
      const title = model.modal_title;
      const content = $content.html();
      const buttonText = model.modal_button_text;
      const buttonAction = () => {window.open(model.modal_button_url, "_blank")};
      Mmg.Modal.show(title, content, {}, {buttonText, buttonAction});
    }
  }
);
